import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ComponentPropsWithoutRef } from "react";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface CommunityContentProps extends ComponentPropsWithoutRef<"div"> {
  disableSidebar?: boolean;
}

export const CommunityContent = ({
  disableSidebar = false,
  children,
  className,
  ...rest
}: CommunityContentProps) => (
  <div
    id="panel"
    data-testid="community-content"
    className={classNames(
      anchorClassNames("community__content trix-v2", {
        "community__content--no-sidebar": disableSidebar,
      }),
      "bg-secondary h-[calc(100vh-48px)] w-full flex-1 overflow-y-auto print:overflow-visible",
      className,
    )}
    data-target="mobile-sidebar.panel"
    {...rest}
  >
    {children}
  </div>
);
